module.exports = __webpack_public_path__ + "assets/img/pdf-guide.7173b0e9.svg";